const mockUsers = [
  {
    id: 1,
    name: 'Sarah',
    email: 'sarah@app.org',
    password: 'react123',
    score: [],
  },
  // Add more users if needed
];

export default mockUsers;
